<template>
  <div>
<!--    <h5><span>*</span> {{label}}</h5>-->
    <DatePicker
      :placeholder="label"
      :clearable="false"
      class="date-picker"
      v-model="localDate"
      @change="updateDate"
      format="DD.MM.YYYY"
      :disabled-date="disabledDates"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

export default {
  name: "DateField",

  components: { DatePicker },

  props: {
    date: {
      type: String,
    },
    label: {
      type: String,
    },
    min: {
      type: String,
    },
    max: {
      type: String,
    }
  },

  created() {
    if(this.date) this.localDate = new Date(this.date)
  },

  data() {
    return {
      localDate: null,
    }
  },

  methods: {
    disabledDates(date) {
      if (this.min) return date < new Date(this.min)
      // if (this.max) return date >= new Date(this.min)
    },

    updateDate(value) {
      this.$emit('updateDate', value)
    }
  },

  watch: {
    date() {
      this.localDate = this.date ? new Date(this.date) : null
    }
  }
}
</script>

<style scoped>

>>>.mx-input {
  border-radius: 20px;
  height: 40px;
  padding: 0 20px;
}

>>>.mx-icon-calendar, .mx-datepicker svg {
  right: 30px;
}

.date-picker {
  width: 100%;
}

h5 span {
  color: red;
}
</style>
